import { useCallback, useEffect, useMemo, useRef } from 'react';

const useDelayTimer = () => {
  const timerRef = useRef<number | null>(null);

  const clear = useCallback(() => {
    if (timerRef.current !== null) {
      window.clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  const schedule = useCallback(
    (callback: () => void, delay: number) => {
      clear();
      timerRef.current = window.setTimeout(callback, delay);
    },
    [clear]
  );

  useEffect(() => clear, [clear]);

  return useMemo(() => ({ clear, schedule }), [clear, schedule]);
};

export default useDelayTimer;
